import React from 'react';

function MakerLoading() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100vw',      
    }} className="WorkBackground">
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16
      }}>
        <div style={{
          width: 50,
          height: 50,
          border: '4px solid rgba(255, 255, 255, 0.3)',
          borderTop: '4px solid #fedf57',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />        
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default MakerLoading;

